export default vm => {
    return vm.profile.customerId
        ? vm.$amntDataProvider
            .get('permissions')
            .then(({ permissions }) => permissions)
            .catch(() => [])
        : Promise.resolve([]);
};
